import { getType } from '@/utils/obj-utils';

export const arraySum = (array, selector) => {
  return array.reduce((prev, current) => prev + selector(current) ?? 0, 0);
};
export const arraySort = (array, element) => {
  return array.sort((a, b) => b[element] - a[element]);
};
export const sortByChar = (array, selector = null, desc = false) => {
  if (!array?.length) return array;
  array.sort((a, b) => {
    let av = selector ? (selector(a) ?? a) : a;
    let bv = selector ? (selector(b) ?? b) : b;
    const direction = desc ? -1 : 1;
    const type = getType(av);
    let result = 0;
    if (type === '[object Number]') {
      result = ((av - bv) / Math.abs(av - bv)) * direction;
    } else if (type === '[object String]') {
      av = av.toLowerCase();
      bv = bv.toLowerCase();
      const len = Math.max(av.length, bv.length);
      for (let i = 0; i < len; i++) {
        if (i > av.length - 1) return direction;
        if (i > bv.length - 1) return -direction;
        const aCode = av.charCodeAt(i),
          bCode = bv.charCodeAt(i);
        if (aCode !== bCode) {
          result = ((aCode - bCode) / Math.abs(aCode - bCode)) * direction;
          break;
        }
      }
    }
    return result;
  });
  return array;
};
export const isSubset = (arr1, arr2) => {
  return arr1.length <= arr2.length && arr1.every((value) => arr2.includes(value));
};
